// Status das assinaturas (gravados pelo back / webhook do Asaas).
export const STATUS_ASSINATURA = {
    ACTIVE: { label: 'Ativa', tone: 'success' },
    PENDENTE: { label: 'Pendente', tone: 'warning' },
    INACTIVE: { label: 'Inativa', tone: 'neutral' },
    EXPIRED: { label: 'Expirada', tone: 'warning' },
    CANCELED: { label: 'Cancelada', tone: 'error' },
    CANCELLED: { label: 'Cancelada', tone: 'error' },
    OVERDUE: { label: 'Em atraso', tone: 'warning' },
};

export const statusAssinatura = (status) =>
    STATUS_ASSINATURA[String(status || '').toUpperCase()] || { label: status || '—', tone: 'error' };
